import React from 'react'

const ComponentGroupPage = React.lazy(() => import('pages/ComponentGroup/ComponentGroupPage'));
const ComponentGroupAddPage = React.lazy(() => import('pages/ComponentGroup/ComponentGroupAddPage'));

const ComponentGroupRoutes = [
    {
        path: '/component-group',
        exact: true,
        name: 'Danh sách nhóm linh kiện',
        function: 'MD_COMPONENTGROUP_VIEW',
        component: ComponentGroupPage,
    },
    {
        path: '/component-group/add',
        exact: true,
        name: 'Thêm mới nhóm linh kiện',
        function: 'MD_COMPONENTGROUP_ADD',
        component: ComponentGroupAddPage,
    },
    {
        path: '/component-group/edit/:id',
        exact: true,
        name: 'Chỉnh sửa nhóm linh kiện',
        function: 'MD_COMPONENTGROUP_EDIT',
        component: ComponentGroupAddPage,
    },
    {
        path: '/component-group/detail/:id',
        exact: true,
        name: 'Chi tiết nhóm linh kiện',
        function: 'MD_COMPONENTGROUP_VIEW',
        component: ComponentGroupAddPage,
    },
]

export default ComponentGroupRoutes
